import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";
import { BookType } from "../types/booksType";

export const getBookHistory = async (): Promise<BookType[]> => {
  try {
    const response: AxiosResponse<BookType[]> = await axiosInstance.get(
      `${apiEndPoints.process}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getLatestBook = async (): Promise<BookType> => {
  try {
    const response: AxiosResponse<BookType> = await axiosInstance.get(
      `${apiEndPoints.latestProcess}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getCloseSummary = async (payloads: {
  month: number;
  year: number;
  investmentRate: number;
  managementRate: number;
  description: string | undefined;
}): Promise<BookType> => {
  try {
    const response: AxiosResponse<BookType> = await axiosInstance.post(
      `${apiEndPoints.process}/summary`,
      payloads
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const runSummary = async (payloads: {
  month: number;
  year: number;
  investmentRate: number;
  managementRate: number;
  description: string | undefined;
}): Promise<BookType> => {
  try {
    const response: AxiosResponse<BookType> = await axiosInstance.post(
      `${apiEndPoints.process}`,
      payloads
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const deleteSummary = async (id: number): Promise<BookType> => {
  try {
    const response: AxiosResponse<BookType> = await axiosInstance.delete(
      `${apiEndPoints.process}/${id}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};
